export enum SubscriptionTypes {
  GET_SUBSCRIPTIONS_ONCE = '@subscription/GET_SUBSCRIPTIONS_ONCE',

  FETCH_SUBSCRIPTIONS_REQUEST = '@subscription/FETCH_SUBSCRIPTIONS_REQUEST',
  FETCH_SUBSCRIPTIONS_FAILURE = '@subscription/FETCH_SUBSCRIPTIONS_FAILURE',
  FETCH_SUBSCRIPTIONS_SUCCESS = '@subscription/FETCH_SUBSCRIPTIONS_SUCCESS',

  CLEAR_SUBSCRIPTIONS = '@subscription/CLEAR_SUBSCRIPTIONS',
}

export interface Subscription {
  _id: string
  name: string
}

export interface SubscriptionState {
  error: any | null
  subscriptions: Subscription[]
  status: 'idle' | 'loading' | 'success' | 'error'
}
